import React from 'react';
import { useTranslation } from 'react-i18next';

import { Table, type TableDropdownListProps } from '@/js/libs/ui/src/V2';

export const TableDropdownList: React.FC<Omit<TableDropdownListProps, 'buttonLabel'>> = React.memo(function TableDropdownList(props) {
  const [t] = useTranslation(['backend', 'common']);

  return <Table.DropdownList buttonLabel={t('common:MORE')} {...props} />;
});
